import { FEATURE_IS_ACTIVE_DEFAULT } from '../constants';
import * as types from '../types';

function setFeatureActive(state, action) {
    const {
        meta: {
            filterId,
            featureId,
        },
        payload: isActive,
    } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            features: {
                ...state[filterId].features,
                [featureId]: isActive,
            },
        },
    };
}

function resetFeatures(state, action) {
    const { meta: filterId } = action;

    const features = Object.keys(state[filterId].features)
        .reduce((map, featureId) => ({
            ...map,
            [featureId]: FEATURE_IS_ACTIVE_DEFAULT,
        }), {});

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            features,
        },
    };
}

export default {
    [types.SET_FEATURE_ACTIVE]: setFeatureActive,
    [types.RESET_FEATURES]: resetFeatures,
};
